export const Field = ({ label, htmlFor, error, required, children, className = "" }) => (
  <div className={className}>
    <label htmlFor={htmlFor} className="label-mono mb-2 block text-steel">
      {label}{required && <span className="text-brand"> *</span>}
    </label>
    {children}
    {error && <p className="mt-2 text-sm text-red-400" data-testid={`${htmlFor}-error`}>{error}</p>}
  </div>
);

export const inputCls = "h-12 rounded-none border-canvas-line bg-canvas text-base text-ink placeholder:text-steel/60 focus-visible:ring-1 focus-visible:ring-brand focus-visible:ring-offset-0";

export const Honeypot = ({ value, onChange }) => (
  <input type="text" name="website" value={value} onChange={onChange} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden />
);

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

export const Success = ({ title, children, onReset, testid }) => (
  <div className="corner-ticks border border-canvas-line bg-canvas-800 p-8 sm:p-10" data-testid={testid} role="status">
    <p className="label-mono text-brand">Received</p>
    <h3 className="mt-4 font-display text-4xl font-bold uppercase leading-none">{title}</h3>
    <div className="mt-5 space-y-3 leading-relaxed text-steel">{children}</div>
    {onReset && (
      <button onClick={onReset} className="label-mono mt-8 text-ink underline-offset-4 hover:text-brand hover:underline" data-testid={`${testid}-reset`}>
        Send another
      </button>
    )}
  </div>
);
